import { CircularProgress, Paper } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getApiUrl } from '../../env'
import ExpandedNews from '../Expanded/ExpandedNews'

const FullSummaryView = ({}) => {
    const [news, setNews] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState("")
    let { id } = useParams();

    useEffect(()=>{
        axios.get(getApiUrl()+id).then(el => {
            setLoading(false)
            setNews(el.data);
          }).catch(err => {
            console.log(err.response.status)
            if (err.response.status==404) {
                setError("Не е пронајдена веста што ја баравте :(")
            }
            else{
                setError("Се случи грешка")
            }
            setLoading(false)
          })
    },[])

    return(
        <div style={{ margin: '10px', color:'white', textAlign:'start' }}>
        {loading ?
            <Paper elevation={1} style={{ textAlign: 'center', padding: '30px' }}>
              <CircularProgress size={100} thickness={5} style={{ marginBottom: '20px' }} />
            </Paper> :
            !error ? <ExpandedNews news={news}/>:<span>{error}</span>
          }
      </div>
    )
}

export default FullSummaryView;